import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import SalesTable from "@/components/sales/sales-table";

const salesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  numericRanges: z.string().optional(),
  /** Filtro por etiqueta (slug). */
  tag: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/sales/")({
  validateSearch: salesSearchSchema,
  component: SalesPage,
});

function SalesPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="space-y-4">
      <SalesTable
        currentPage={searchParams.page}
        basePath="/sales"
        searchParams={searchParams}
      />
    </div>
  );
}
